import { GALLERY } from "@/data/teamData";

export default function Gallery() {
  return (
    <section id="galeri" data-testid="gallery-section" className="bg-white text-[#050B14]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-24">
        <div className="mb-12 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="text-xs font-bold tracking-[0.3em] text-[#E63946] mb-3">MOMEN TERBAIK</div>
            <h2 className="font-display text-5xl sm:text-6xl leading-none">
              GALERI <span className="text-[#E63946]">HIGHLIGHT</span>
            </h2>
            <p className="mt-4 text-[#050B14]/70">
              Setiap gol, setiap tackle, setiap teriakan kemenangan — tersimpan di sini.
            </p>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 auto-rows-[200px]">
          {GALLERY.map((g, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative group overflow-hidden bg-[#F6F7F9] border border-[#050B14]/10 ${
                g.tall ? "row-span-2" : ""
              } ${i === 0 ? "md:col-span-2" : ""}`}
            >
              <img
                src={g.src}
                alt={g.caption}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="font-display text-xl text-white">{g.caption}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
